import script from "./TicketCreateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketCreateDialog.vue?vue&type=script&setup=true&lang=js"

import "./TicketCreateDialog.vue?vue&type=style&index=0&id=c36aed38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c36aed38"]])

export default __exports__